import { TFunction } from 'i18next';
import { InferType, object, string } from 'yup';


//* Types and schemas related to the form validation for the Login page
export const LoginValidationSchema = (t: TFunction) => {
  return object({
    email: string()
      .required(t("form.required"))
      .email(t("form.invalidEmail")),
    password: string().required(t("form.required")),
  });
};

export type LoginValidationType = InferType<ReturnType<typeof LoginValidationSchema>>;